// Calendario edizioni corsi in presenza — Pisa, novembre 2026.
// Chiave = slug interno del corso (coincide con CORSI[].slug in mock.js e landings[].courseSlug).
// seatsLeft = posti ancora disponibili (modificabile a mano man mano che arrivano le iscrizioni).
export const COURSE_LOCATION = "In aula a Pisa";

export const COURSE_SCHEDULE = {
  "social-media-marketing": {
    date: "Venerdì 6 novembre 2026",
    time: "9:00–19:00",
    duration: "9 ore in aula",
    deadline: "Venerdì 30 ottobre 2026",
    deadlineISO: "2026-10-30T23:59:59+01:00",
    seatsLeft: 8,
  },
  "agenti-ai": {
    date: "Sabato 7 novembre 2026 — mattina",
    time: "9:00–14:00",
    duration: "5 ore in aula",
    deadline: "Venerdì 30 ottobre 2026",
    deadlineISO: "2026-10-30T23:59:59+01:00",
    seatsLeft: 10,
  },
  "customer-loyalty": {
    date: "Sabato 7 novembre 2026 — pomeriggio",
    time: "15:00–20:00",
    duration: "5 ore in aula",
    deadline: "Venerdì 30 ottobre 2026",
    deadlineISO: "2026-10-30T23:59:59+01:00",
    seatsLeft: 10,
  },
  "controlla-la-tua-comunicazione-digitale": {
    date: "Venerdì 13 novembre 2026",
    time: "9:00–19:00",
    duration: "9 ore in aula",
    deadline: "Venerdì 6 novembre 2026",
    deadlineISO: "2026-11-06T23:59:59+01:00",
    seatsLeft: 8,
  },
  "facebook-advanced": {
    date: "Sabato 14 novembre 2026",
    time: "9:00–17:00",
    duration: "7 ore in aula",
    deadline: "Venerdì 6 novembre 2026",
    deadlineISO: "2026-11-06T23:59:59+01:00",
    seatsLeft: 8,
  },
};

export const getSchedule = (slug) => COURSE_SCHEDULE[slug] || null;
